import React from 'react';
import PropTypes from 'prop-types';
import CommonModal from '../Common/Modal/Modal';
import Button from '../Button/Button';
import Icon from '../Icons/Icon';

const AccountDetailsModal = ({
  user = null, onClose, onResendEmail, organization,
}) => {
  if (!user) return null;

  return (
    <CommonModal
      isOpen
      handleClose={onClose}
      title="Account details"
      titlePosition="left"
      headerClassName="pl-8 pt-8 pb-6"
      minWidth="min-w-[520px]"
    >
      {!user.confirmed_at && (
        <div className="pt-6 w-2/3 mx-auto">
          <div className="flex gap-2 bg-vamos-v-light-gray rounded-md py-6 px-4">
            <Icon name="icon_circle" className="w-5 h-5" />
            <p className="text-lg font-normal text-left leading-tight">You can re-send the user’s account registration email. This is useful when the user hasn’t received the email, or if the invitation has expired.</p>
          </div>
        </div>
      )}
      <div className="p-6 w-2/3 mx-auto">
        <h4 className="text-lg font-bold text-left leading-tight">REGISTRATION CONFIRMATION</h4>
        <div className="flex justify-between pt-6 text-lg font-medium leading-tight">
          <p>Status</p>
          <div className="flex gap-x-1 items-center">
            <Icon name={user.confirmed_at ? 'check_circle' : 'alert_orange'} className="w-5 h-5" />
            <p className="font-normal">{user.confirmed_at ? `Confirmed on ${user.confirmed_at}` : 'Not confirmed'}</p>
          </div>
        </div>
        <div className="flex justify-between pt-8 text-lg font-medium leading-tight">
          <p>Last sent</p>
          <p className="font-normal">{user.confirmation_sent_at}
          </p>
        </div>
      </div>
      <div className="p-8 place-items-end">
        <Button label={user.confirmed_at ? 'Close' : 'Resend'} size="md" onClick={user.confirmed_at ? onClose : () => onResendEmail(user.id, organization.id)} />
      </div>
    </CommonModal>
  );
};

AccountDetailsModal.propTypes = {
  user: PropTypes.shape({
    confirmed_at: PropTypes.string,
    date_registered: PropTypes.string,
    id: PropTypes.number.isRequired,
    confirmation_sent_at: PropTypes.string,

  }),
  onClose: PropTypes.func.isRequired,
  onResendEmail: PropTypes.func.isRequired,
  organization: PropTypes.object.isRequired,
};

export default AccountDetailsModal;
